import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import {  useNavigate, useParams, useLocation } from "react-router-dom"
import { useGetTasksQuery } from '../tasks/tasksApiSlice'
import { useEffect, useState } from "react"
import GradesList from "./GradesList"
import GradesUpdatedList from "./GradesUpdatedList"
import GradesGlobalFindList from "./GradesGlobalFindList"
import useQueryParams from "../../hooks/useQueryParams"
import { faFilter, faFilterCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
function GradesListFilter() {
    useTitle('geshtop-Exercise: Grades List')
    const {taskId, groupId, type} = useParams()

    const { q, qName } = useQueryParams()

    const { tasks } = useGetTasksQuery("tasksList", {
        selectFromResult: ({ data }) => ({
            tasks: data?.ids.map(id => data?.entities[id])
        }),
    })
    //const {data} = useGetGradesQuery({taskId})
    const navigate = useNavigate()
    const[task,setTask] = useState(taskId)
    const[qq,setQQ] = useState(q || "")
    const[qqName,setQQName] = useState(qName || "")

    const onClickFilter = ()=>{
        const t = task || "0"
      
        if(qq || qqName){
            navigate(`/${type}/${groupId}/grades/task/${t}/search?q=${encodeURIComponent( qq)}&qName=${encodeURIComponent(qqName)}`) 
        }else{
            if(t!=="0")
                navigate(`/${type}/${groupId}/grades/task/${t}`)
            else
                navigate(`/${type}/${groupId}/grades`)
        }
    }
    if (!tasks?.length) return <PulseLoader color={"#FFF"} />
    const filterTasks = groupId!=='0'? tasks.filter(task=>task.group===groupId) : [...tasks]
    //console.log(filterTasks)
    const options = filterTasks?.map(task => {
        return (
            <option
                key={task.id}
                value={task.id}
            >{task.title} {task.groupname && ` - ${task.groupname}`}  {task.groupyear && ` - ${task.groupyear}`} </option >
        )
    })
  


    const selectTaskOnChange=async (e)=>{
        const val = e.target.value
        setTask(val)
       

    }
   
    
    const content =(<>
        <div className="filter-form wrap">
            <div className="filter-form-item">
                <div className="form-input-container">
                        <select
                            id="task"
                            name="task"
                            className={`form__input`}
                            value={task}
                            onChange={selectTaskOnChange}
                        >
                            <option value="">--בחר משימה--</option>
                            {options}
                        </select>
                    </div>
    
            </div>
            <div className="filter-form-item">
                <div className="form-input-container">
                    <input  type="text" placeholder="חיפוש בביצוע"  defaultValue={q} className={`form__input form__input--ltr`} onChange={(e)=>setQQ(e.target.value.toLowerCase())} />
                </div>
    
            </div>
            
            <div className="filter-form-item">
                <div className="form-input-container">
                    <input type="text" defaultValue={qName} placeholder="חיפוש לפי שם"  className={`form__input`} onChange={(e)=>setQQName(e.target.value.toLowerCase())} />
                       
                </div>
    
            </div>
            <div className="filter-form-item">
                <div className="form-input-container">
                  <button
                            className="icon-button"
                            title="Filter"
                            onClick={onClickFilter}
                        >
                            <FontAwesomeIcon icon={faFilter} />
                        </button>
                </div>
    
            </div>
            <div className="filter-form-item">
                <div className="form-input-container">
                  <button
                            className="icon-button"
                            title="Remove Filter"
                            onClick={()=>  {setQQ(""); setQQName(""); navigate(`/${type}/${groupId}/grades`)}}
                        >
                            <FontAwesomeIcon icon={faFilterCircleXmark} />
                        </button>
                </div>
    
            </div>
    
        </div>
        {(q || qName) ?  <GradesGlobalFindList  />  :  ( taskId ?  <GradesList  /> :<GradesUpdatedList />  ) }
       
    
    </> ) 

  return content;
}

export default GradesListFilter